import { Component, inject, input, output } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AuthService } from '../../auth/auth.service';
import { UserContextService } from '../../auth/user-context.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [MatToolbarModule, MatButtonModule, MatIconModule],
  template: `
    <mat-toolbar color="primary" class="app-header">
      @if (showHamburger()) {
        <button mat-icon-button (click)="toggleSidebar.emit()" aria-label="Menu">
          <mat-icon>menu</mat-icon>
        </button>
      }
      <img src="assets/logo-veolia.png" alt="Veolia" class="veolia-logo" />
      <span class="app-title">Marqueo</span>
      <span class="spacer"></span>
      @if (userCtx.userEmail) {
        <span class="user-email">{{ userCtx.userEmail }}</span>
      }
      <button mat-button (click)="logout()">Déconnexion</button>
    </mat-toolbar>
  `,
  styles: [`
    .app-header { height: 58px; background: linear-gradient(90deg, #004878, #0064A0) !important; }
    .spacer { flex: 1; }
    .veolia-logo { height: 36px; width: auto; margin-right: 10px; object-fit: contain; }
    .app-title { font-size: 1.1rem; font-weight: 600; letter-spacing: 0.02em; }
    .user-email { font-size: 0.85em; margin-right: 8px; opacity: 0.87; }
  `],
})
export class HeaderComponent {
  protected readonly userCtx = inject(UserContextService);
  private readonly authService = inject(AuthService);

  readonly showHamburger = input(false);
  readonly toggleSidebar = output<void>();

  logout(): void {
    this.authService.logout();
  }
}
